export default __webpack_public_path__ + "static/media/ZAMKNIJ.537c4176.svg";